module.exports = __webpack_public_path__ + "static/parade-2020-house53-ec4b29c815f48637e997e82fc09514c2.jpg";